import { useState,useEffect } from "react";
import ApiService from "../../services/apiService";
import SearchMap from "../svg/SearchMap";
const SearchBox = ({ ZoomToInitialPosition }: any) => {

  const [searchQuerys,setSearchQuerys] = useState<any>()
  const [chackData,setChackData] = useState<any>()
  const [filteredDatas, setFilteredData] = useState<any[]>([]);
  const [selectedChack, setSelectedChack] = useState<any>(null);
  const [showDropdown, setShowDropdown] = useState(true);
  const [selectedId,setSelectedId] = useState(null);
  const [showInput,setShowInput] = useState<any>(false);


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuerys(e.target.value);
    setShowDropdown(true);
    //onSearch(e.target.value); // Trigger the search function

    const filteredResults = chackData.filter((chack: any) =>
      chack.chackName.toLowerCase().startsWith(e.target.value.toLowerCase())
    );
   
    setFilteredData(filteredResults);
  };

 /* const handleSelectChack = (chack: any) => {
    setSearchQuery(chack.chackName);  // Update search box with the selected chack's name
    onSelectChack(chack); // Pass the selected chack to the parent component
  };*/

  const fetchData = async () => {
    try {
      const response = await ApiService.axiosApi('/chack', {
        method: 'GET',
        params:{
           pageNumber:0,
           pageSize:0
        }
      });

      if (response.success) {
        setChackData(response.data.data);
      } else {
        console.log('Unable to fetch chack data');
      }
    } catch (error) {
      console.error('Error fetching chack data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /*const handleSearch = debounce(async (value: any) => {
    setSearchQuerys(value);
    setShowDropdown(true)
    
    const filteredResults = chackData.filter((chack: any) =>
      chack.chackName.toLowerCase().startsWith(value.toLowerCase())
    );
   
    setFilteredData(filteredResults);
  }, 300);*/

  const handleSelectChack = (chack: any) => {
    setSearchQuerys(chack.chackName);  // Update search box with selected chack's name
    setSelectedChack(chack); // Store the selected chack for zooming purposes
    setSelectedId(chack.id)
    setTimeout(() =>  setSelectedId(null), 2000);
    setShowDropdown(false)
    setShowInput(false)
    setSearchQuerys('')

   
  };
  ZoomToInitialPosition(selectedId,selectedChack);

  



  return (
    <>
    <button onClick={()=>{setShowInput(true)} } color="primary" style={{position:'absolute',
        top:'75px',
        left:'12px',
        backgroundColor:'rgb(255, 255, 255',
        zIndex:1,
        height:'31px',
        width:'30px',
        border:'none',
        borderRadius:'2px'}}>
         <SearchMap/>
       </button>
   
    <div >

     {showInput&&<input
        className="b-r-5 map-input"
        value={searchQuerys}
        onChange={handleInputChange}
        placeholder="Search ChackName..."

        style={{
          position: 'absolute',
          top: 40,
          left: 50,
          zIndex: 1,
          width: '268px',
          height: '35px',

          borderColor: 'transparent',
        }} 
      
      /> }
      {filteredDatas.length > 0 && showDropdown && (
        <div
        className="mapdropdown"
          style={{
            position: 'absolute',
            top: '80px',
            left: '50px',
            borderRadius: '5px',
            boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
            zIndex: 1,
            overflowY: 'hidden',
           
          }}
        >
          <div
           className="mapdropdown"
            style={{
              
              width: '268px',
              maxHeight: '200px',
              overflowY: 'auto',
              padding: '10px',
              scrollbarWidth: 'thin',
              
            }}
          >
            <div  className="mapdropdown"style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
              <span style={{ fontWeight: 'bold' }}>Results:</span>

            </div>
            {filteredDatas.map((chack: any, index: number) => (
              <div
               className="mapdropdown"
                key={index}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #ccc',
                }}
                onClick={() => handleSelectChack(chack)} // Trigger select when a chack is clicked
              >
                {chack.chackName}
              </div>
            ))}
             </div>
          </div>
        )}
       
        </div>
        </>
      );
  };

      export default SearchBox;
